import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      layout: 'default'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: {
      layout: 'default'
    }
  },
  {
    path: '/students',
    name: 'Students',
    component: () => import('../views/Students.vue'),
    meta: {
      layout: 'default'
    }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('../views/Privacy.vue'),
    meta: {
      layout: 'default'
    }
  },
  {
    path: '/error-report',
    name: 'ErrorReport',
    component: () => import('../views/ErrorReport.vue'),
    meta: {
      layout: 'default'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      layout: 'auth'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue'),
    meta: {
      layout: 'auth'
    }
  },
  {
    path: '/register-confirm',
    name: 'RegisterConfirm',
    component: () => import('../views/RegisterConfirm.vue'),
    meta: {
      layout: 'auth'
    }
  },
  {
    path: '/auth/rstpsswrd',
    name: 'RestorePassword',
    component: () => import('../views/auth/RestorePassword.vue'),
    meta: {
      layout: 'auth'
    }
  },
  {
    path: '/auth/resetpasswrd/:t',
    name: 'ResetPassword',
    // props: true,
    component: () => import('../views/auth/ResetPassword.vue'),
    meta: {
      layout: 'auth'
    }
  },
  {
    path: '/auth/reset-cancel/:t',
    name: 'ResetCancel',
    // props: true,
    component: () => import('../views/auth/ResetPasswordCancel.vue'),
    meta: {
      layout: 'auth'
    }
  },
  {
    path: '/exam/begin',
    name: 'ExamBegin',
    component: () => import('../views/ExamBegin.vue'),
    meta: {
      layout: 'dashboard',
      auth: true
    }
  },
  {
    path: '/exam/e/:id',
    name: 'Exam',
    component: () => import('../views/Exam.vue'),
    meta: {
      // layout: 'dashboard',
      layout: 'exam',
      auth: true
    }
  },
  {
    path: '/exam/r/:id',
    name: 'ExamResult',
    component: () => import('../views/ExamResult.vue'),
    meta: {
      layout: 'dashboard',
      // layout: 'exam',
      auth: true
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: {
      layout: 'dashboard',
      auth: true
    }
  },
  {
    path: '/dashboard/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue'),
    meta: {
      layout: 'dashboard',
      auth: true
    }
  },
  {
    path: '*',
    component: () => import('../views/404.vue'),
    meta: {
      layout: 'default'
    }
  }
  // {
  //   path: '/exam',
  //   name: 'Exam',
  //   component: () => import('../views/Exam.vue'),
  //   meta: {
  //     layout: 'exam',
  //     auth: true
  //   }
  // }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, form, next) => {
  const isLoggedIn = store.getters.isLoggedIn;
  const requireAuth = to.matched.some(record => record.meta.auth);

  const sidebarState = store.getters.sidebarOpened;
  const offCanvasNavState = store.getters.offCanvasNavState;
  if (sidebarState) store.commit('setSidebarState', false);
  if (offCanvasNavState) store.commit('setO ffCanvasNavState', false);

  if (isLoggedIn && (to.name === 'Login' || to.name === 'Register')) {
    next('/dashboard');
    return;
  }

  if (requireAuth) {
    if (isLoggedIn) {
      console.log('router - isLoggedIn');
      next();
      return;
    }
    console.log('1');
    next('/login');
  } else {
    console.log('2');
    next();
  }
});

export default router;
